export default __webpack_public_path__ + "static/media/books2-afterB-768w.aa54d64f.avif";